module.exports = __webpack_public_path__ + "static/media/Recipes.abd69db4.jpg";